import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLottolandSmileLogo = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 5"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23.443.014c-3.687 1.161-7.48 1.875-11.306 1.875-3.824 0-7.633-.713-11.305-1.875C.587-.063.388.2.572.4 2.79 2.647 5.804 4.041 8.894 4.63a17.6 17.6 0 0 0 3.243.31 17.6 17.6 0 0 0 3.244-.31C18.47 4.025 21.47 2.647 23.703.4c.169-.201-.015-.464-.26-.387"
      />
    </svg>
  );
};
export default SvgLottolandSmileLogo;
